export default {
    PLEASE_PRESS_ESC: "Нажмите esc",
    FOR_ESCAPE_FROM_MODE: "для выхода из режима",
    ADDING_LOCATION_LINE_HINT: "Для завершения редактирования линии кликните по ее последней точке повторно",
    ADDING_LOCATION_AREA_HINT: "Для завершения редактирования области кликните по ее последней точке повторно"
};
